<template>
	<AdUnit v-if="actualAdIndex" :adPosition="'inlist_' + actualAdIndex" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import AdUnit from '@/components/AdUnit.vue';

const props = withDefaults(
	defineProps<{
		index: number;
		everyXBuckets?: number;
		firstAdAt?: number;
		capsAt?: number;
	}>(),
	{
		everyXBuckets: 4,
		firstAdAt: 0,
		capsAt: 3,
	}
);

const actualAdIndex = computed(() => {
	if (props.index < props.firstAdAt) return false;

	const i = (props.index - props.firstAdAt) / props.everyXBuckets;
	const isNotFloat = i % 1 === 0;
	const isNotCapped = i < props.capsAt;
	return isNotFloat && isNotCapped ? i + 1 : false;
});
</script>
